/** Permission keys — use with {@link hasPermission}. */
export const PERMISSIONS = {
  WATCHTOWER_VIEW: 'watchtower:view',
  DASHBOARD_VIEW: 'dashboard:view',
  DATABASE_VIEW: 'database:view',
};

export const DEFAULT_ADMIN_USER = {
  id: 'base-admin',
  name: 'Admin User',
  email: 'admin@tejasfleets.com',
  role: 'super_admin',
  permissions: ['*'],
};

export const ROLE_PERMISSIONS = {
  super_admin: ['*'],
  /** Same privilege set as super_admin; some DB seeds use `admin`. */
  admin: ['*'],
  operations_manager: [
    'dashboard:view',
    'bookings:view',
    'broadcasts:view',
    'vendors:view',
    'vendor-notifications:view',
    'vendor-notifications:manage',
    'vendor-penalties:view',
    'vendor-penalties:manage',
    'cabs-fleet:view',
    'cabs-approval:view',
    'cabs-approval:manage',
    'cab-expenses:view',
    'cab-revenue:view',
    'cab-sold-out:view',
    'drivers-roster:view',
    'driver-approval:view',
    'driver-approval:manage',
    'driver-salary-slip:view',
    'driver-expenses:view',
    'pricing:view',
    'routes:view',
    'distance-calculator:view',
    'cities:view',
    'route-pages:view',
    'seo:view',
    'seo:manage',
    'checkout-addons:view',
    'snack-box:view',
    'snack-box:manage',
    'nearby-places:view',
    'nearby-places:manage',
    'luxury-cars:view',
    'luxury-cars:manage',
    'luxury-cars:publish',
    'luxury-cars:seo',
    'luxury-cars:tariff',
    'luxury-cars:packages',
    'luxury-cars:settings',
    'luxury-cars:activities',
    'dmc:view',
    'dmc:manage',
    'business-presence:view',
    'business-presence:manage',
    'checkout-online-payment-options:view',
    'checkout-terms-conditions:view',
    'cms-route-pages:view',
    'cms-route-pages-css:view',
    'homepage-popular-routes:view',
    'homepage-popular-route-categories:view',
    'faq-categories:view',
    'faqs:view',
    'blog-posts:view',
    'blog-posts:manage',
    'blog-categories:view',
    'blog-tags:view',
    'blog-tags:manage',
    'reviews:view',
    'reviews:manage',
    'segment-configuration:view',
    'users:view',
    'corporate:view',
    'corporate:manage',
    'corporate-cms:view',
    'corporate-cms:manage',
    'ashtavinayak-cms:view',
    'ashtavinayak-cms:manage',
    'analytics:view',
    'utm_tracking:view',
    'utm_tracking:export',
    'utm_tracking:manage',
    'google_ads:view',
    'google_ads:manage',
    'google_ads:export',
    'ai_visibility:view',
    'ai_visibility:manage',
    'ai_visibility:export',
    'ads:view',
    'ads:manage',
    'finance:view',
    'watchtower:view',
    'logs:view',
    'settings:view',
    'acl:view',
  ],
  marketing_manager: [
    'dashboard:view',
    'analytics:view',
    'utm_tracking:view',
    'utm_tracking:export',
    'utm_tracking:manage',
    'google_ads:view',
    'google_ads:manage',
    'google_ads:export',
    'ai_visibility:view',
    'ai_visibility:manage',
    'ai_visibility:export',
    'bookings:view',
    'settings:view',
  ],
  reporting_viewer: [
    'dashboard:view',
    'analytics:view',
    'google_ads:view',
    'google_ads:export',
    'ai_visibility:view',
    'ai_visibility:export',
    'utm_tracking:view',
    'utm_tracking:export',
  ],
  seo_manager: [
    'dashboard:view',
    'blog-posts:view',
    'blog-posts:manage',
    'blog-categories:view',
    'blog-tags:view',
    'blog-tags:manage',
    'seo:view',
    'seo:manage',
    'ai_visibility:view',
    'ai_visibility:manage',
    'ai_visibility:export',
    'ashtavinayak-cms:view',
    'ashtavinayak-cms:manage',
  ],
  editor: [
    'dashboard:view',
    'blog-posts:view',
    'blog-posts:manage',
    'blog-categories:view',
    'blog-tags:view',
  ],
  writer: [
    'dashboard:view',
    'blog-posts:view',
    'blog-posts:manage',
    'blog-categories:view',
    'blog-tags:view',
  ],
  support_agent: [
    'dashboard:view',
    'watchtower:view',
    'bookings:view',
    'broadcasts:view',
    'vendors:view',
    'vendor-notifications:view',
    'vendor-notifications:manage',
    'vendor-penalties:view',
    'vendor-penalties:manage',
    'reviews:view',
    'logs:view',
    'settings:view',
  ],
};


const MENU_PERMISSION = {
  dashboard: 'dashboard:view',
  'api-docs': 'dashboard:view',
  watchtower: 'watchtower:view',
  bookings: 'bookings:view',
  'support-tickets': 'bookings:view',
  'contact-group': 'bookings:view',
  'contact-messages': 'bookings:view',
  'contact-form-settings': 'bookings:view',
  'crm-group': 'bookings:view',
  'crm-call-logs': 'bookings:view',
  'crm-complaints': 'bookings:view',
  'crm-refund-tickets': 'bookings:view',
  'crm-escalation': 'bookings:view',
  'crm-whatsapp': 'logs:view',
  'booking-view': 'bookings:view',
  'booking-edit': 'bookings:view',
  'booking-activity': 'bookings:view',
  'booking-invoices': 'bookings:view',
  'booking-transactions': 'bookings:view',
  'booking-manual-broadcast': 'bookings:view',
  'guest-vendor-interests': 'bookings:view',
  'vendor-cab-availability': 'bookings:view',
  'booking-leads': 'bookings:view',
  'booking-quotes': 'bookings:view',
  broadcasts: 'broadcasts:view',
  vendors: 'vendors:view',
  'vendor-join-us-enquiries': 'vendors:view',
  'pan-india-vendors': 'vendors:view',
  'vendor-onboarding-campaigns': 'vendors:view',
  'vendor-onboarding-form': 'settings:view',
  'vendor-notifications': 'vendor-notifications:view',
  'vendor-penalties': 'vendor-penalties:view',
  'finance-group': 'finance:view',

  'finance-dashboard': 'finance:view',
  'finance-vehicle-ledger': 'finance:view',
  'finance-expenses': 'finance:view',
  'finance-fastag-import': 'finance:view',
  'finance-zoho-export': 'finance:view',
  'finance-driver-ledger': 'finance:view',
  'finance-vendor-finance': 'finance:view',
  'finance-vendor-settlement': 'finance:view',
  'finance-fleet-utilization': 'finance:view',
  'finance-driver-performance': 'finance:view',
  'finance-gst-summary': 'finance:view',
  'finance-vehicle-pl': 'finance:view',
  'finance-vendor-payouts': 'finance:view',
  'finance-driver-settlements': 'finance:view',
  'finance-toll-fuel': 'finance:view',
  'finance-gst-invoices': 'finance:view',
  'finance-customer-payments': 'finance:view',
  'finance-fleet-profitability': 'finance:view',
  'finance-emi-loans': 'finance:view',
  'finance-route-pl': 'finance:view',
  'finance-multi-vendor': 'finance:view',
  'finance-reconciliation': 'finance:view',
  'finance-checkout-addons-report': 'finance:view',
  'finance-snackbox-orders-report': 'finance:view',
  'cabs-fleet': 'cabs-fleet:view',
  'cabs-approval': 'cabs-approval:view',
  'cab-expenses': 'cab-expenses:view',
  'cab-revenue': 'cab-revenue:view',
  'cab-sold-out': 'cab-sold-out:view',
  'drivers-roster': 'drivers-roster:view',
  'driver-approval': 'driver-approval:view',
  'driver-salary-slip': 'driver-salary-slip:view',
  'driver-expenses': 'driver-expenses:view',
  'pricing-group': 'pricing:view',
  pricing: 'pricing:view',
  'pricing-vendor-pricing': 'pricing:view',
  'pricing-price-analysis': 'pricing:view',
  'pricing-price-analysis-history': 'pricing:view',
  'pricing-configuration': 'pricing:view',
  'pricing-test': 'pricing:view',
  'tours-packages-group': 'pricing:view',
  'cab-tour-packages': 'pricing:view',
  'jyotirlinga-engine': 'pricing:view',
  'ashtavinayak-tours': 'ashtavinayak-cms:view',
  'ashtavinayak-temples': 'ashtavinayak-cms:view',
  'pilgrimage-sites': 'pricing:view',
  'cab-package-enquiries': 'pricing:view',
  'cab-package-user-logged': 'pricing:view',
  'route-page-user-logged': 'route-pages:view',
  'vehicle-landing-user-logged': 'routes:view',
  'tours-packages-settings': 'pricing:view',
  'nearby-places': 'nearby-places:view',
  'luxury-cars-group': 'luxury-cars:view',
  'luxury-cars-dashboard': 'luxury-cars:view',
  'luxury-cars-cities': 'luxury-cars:view',
  'luxury-cars-fleet': 'luxury-cars:view',
  'luxury-cars-tariffs': 'luxury-cars:view',
  'luxury-cars-packages': 'luxury-cars:view',
  'luxury-cars-pages': 'luxury-cars:view',
  'luxury-cars-faqs-group': 'luxury-cars:view',
  'luxury-cars-faqs': 'luxury-cars:view',
  'luxury-cars-faq-categories': 'luxury-cars:view',
  'luxury-cars-faq-import': 'luxury-cars:manage',
  'luxury-cars-faq-templates': 'luxury-cars:view',
  'luxury-cars-faq-analytics': 'luxury-cars:view',
  'luxury-cars-enquiries': 'luxury-cars:view',
  'luxury-cars-bookings': 'luxury-cars:view',
  'luxury-cars-vendors': 'luxury-cars:view',
  'luxury-cars-settings': 'luxury-cars:view',
  'luxury-cars-terms': 'luxury-cars:view',
  'luxury-cars-activities': 'luxury-cars:view',
  'dmc-center-group': 'dmc:view',
  'dmc-cab-prospects': 'dmc:view',
  'dmc-package-prospects': 'dmc:view',
  'business-presence-group': 'business-presence:view',
  'business-presence-dashboard': 'business-presence:view',
  'business-presence-locations': 'business-presence:view',
  'business-presence-posts': 'business-presence:view',
  'business-presence-reviews': 'business-presence:view',
  'business-presence-accounts': 'business-presence:view',
  'business-presence-seo': 'business-presence:view',
  'business-presence-settings': 'business-presence:manage',
  routes: 'routes:view',
  'routes-settings': 'routes:view',
  'distance-calculator': 'distance-calculator:view',
  'location-missing-searches': 'cities:view',
  'location-search-index': 'cities:view',
  'location-master-ops': 'cities:view',
  cities: 'cities:view',
  'route-pages': 'route-pages:view',
  'seo-control-center': 'seo:view',
  'seo-page-urls': 'seo:view',
  'seo-score-dashboard': 'seo:view',
  'locality-landing-cms': 'seo:view',
  'city-money-pages': 'seo:view',
  'seo-engine-group': 'seo:view',
  'seo-engine-dashboard': 'seo:view',
  'seo-engine-cities': 'seo:view',
  'seo-engine-states': 'seo:view',
  'seo-engine-localities': 'seo:view',
  'seo-engine-routes': 'seo:view',
  'seo-engine-services': 'seo:view',
  'seo-engine-keywords': 'seo:view',
  'seo-engine-pages': 'seo:view',
  'seo-engine-templates': 'seo:view',
  'seo-engine-blocks': 'seo:view',
  'seo-engine-faqs': 'seo:view',
  'seo-engine-redirects': 'seo:view',
  'seo-engine-sitemap': 'seo:view',
  'seo-engine-audit': 'seo:view',
  'seo-engine-internal-links': 'seo:view',
  'seo-engine-schema': 'seo:view',
  'ai-seo-group': 'seo:view',
  'ai-seo-overview': 'seo:view',
  'ai-seo-how-to': 'seo:view',
  'ai-seo-providers': 'seo:manage',
  'ai-seo-models': 'seo:manage',
  'ai-seo-routing': 'seo:manage',
  'ai-seo-settings': 'seo:manage',
  'ai-seo-prompts': 'seo:manage',
  'ai-seo-keywords': 'seo:view',
  'ai-seo-content': 'seo:view',
  'ai-seo-calendar': 'seo:view',
  'ai-seo-social': 'seo:view',
  'ai-seo-knowledge': 'seo:view',
  'ai-seo-usage': 'seo:view',
  sitemaps: 'seo:view',
  'robots-txt': 'seo:view',
  'seo-settings': 'settings:view',
  'seo-group': 'seo:view',
  'checkout-addons': 'checkout-addons:view',
  'snack-box-dashboard': 'snack-box:view',
  'snack-box-management-group': 'snack-box:view',
  'snack-boxes': 'snack-box:view',
  'snack-box-inventory': 'snack-box:view',
  'snack-box-orders': 'snack-box:view',
  'snack-box-reports': 'snack-box:view',
  'snack-box-settings': 'snack-box:view',
  'checkout-online-payment-options': 'checkout-online-payment-options:view',
  'checkout-terms-conditions': 'checkout-terms-conditions:view',
  'cms-route-pages': 'cms-route-pages:view',
  'cms-route-pages-editor': 'cms-route-pages:view',
  'cms-route-pages-css': 'cms-route-pages-css:view',
  'homepage-popular-routes': 'homepage-popular-routes:view',
  'homepage-popular-route-categories': 'homepage-popular-route-categories:view',
  'homepage-group': 'homepage-popular-routes:view',
  'homepage-header': 'homepage-popular-routes:view',
  'homepage-hero-banner': 'homepage-popular-routes:view',
  'homepage-footer': 'homepage-popular-routes:view',
  'homepage-not-found': 'homepage-popular-routes:view',
  'homepage-sections': 'homepage-popular-routes:view',
  'gallery-share-settings': 'homepage-popular-routes:view',
  'faq-categories': 'faq-categories:view',
  'faqs': 'faqs:view',
  'faq-group': 'faqs:view',
  'blog-posts': 'blog-posts:view',
  'blog-posts-editor': 'blog-posts:view',
  'blog-seo-dashboard': 'blog-posts:view',
  'blog-calendar': 'blog-posts:view',
  'blog-keywords': 'blog-posts:view',
  'blog-clusters': 'blog-posts:view',
  'blog-authors': 'blog-posts:view',
  'blog-internal-links': 'blog-posts:view',
  'blog-seo-audit': 'blog-posts:view',
  'blog-cannibalization': 'blog-posts:view',
  'blog-redirects': 'blog-posts:view',
  'blog-categories': 'blog-categories:view',
  'blog-tags': 'blog-tags:view',
  'blog-comments': 'blog-posts:view',
  'reviews': 'reviews:view',
  'reviews-group': 'reviews:view',
  'review-automation': 'reviews:view',
  'review-automation-dashboard': 'reviews:view',
  'review-automation-requests': 'reviews:view',
  'review-automation-reports': 'reviews:view',
  'review-automation-settings': 'reviews:manage',
  'segment-configuration': 'segment-configuration:view',
  users: 'users:view',
  'customers-group': 'users:view',
  'customer-activities-log': 'users:view',
  'corporate-group': 'corporate:view',
  'corporate-clients': 'corporate:view',
  'corporate-pending': 'corporate:view',
  'corporate-bookings': 'corporate:view',
  'corporate-pricing': 'corporate:manage',
  'corporate-contracts': 'corporate:manage',
  'corporate-invoices': 'corporate:view',
  'corporate-reports': 'corporate:view',
  'corporate-erp': 'corporate:manage',
  'corporate-client-detail': 'corporate:view',
  'corporate-cms-group': 'corporate-cms:view',
  'corporate-cms-hub': 'corporate-cms:view',
  'corporate-cms-cities': 'corporate-cms:view',
  'corporate-cms-services': 'corporate-cms:view',
  'corporate-cms-packages': 'corporate-cms:view',
  'corporate-cms-enquiries': 'corporate-cms:view',
  'corporate-cms-localities': 'corporate-cms:view',
  'customer-view': 'users:view',
  'customer-edit': 'users:view',
  'finance-invoices-group': 'finance:view',
  'finance-vendor-settlement-group': 'finance:view',
  'finance-reports-group': 'finance:view',
  'acl-access-control': 'acl:view',
  'notification-center': 'settings:view',
  'system-tools-group': 'dashboard:view',
  analytics: 'analytics:view',
  'analytics-advanced': 'analytics:view',
  'analytics-booking-funnel': 'analytics:view',
  'analytics-cancellations': 'analytics:view',
  'analytics-coupon-usage': 'analytics:view',
  'analytics-cookie-consent': 'analytics:view',
  // Group visibility is driven by children ACL; keep a permissive key for group clicks.
  'marketing-group': 'dashboard:view',
  'marketing-leads': 'analytics:view',
  'newsletter-subscribers': 'analytics:view',
  'newsletter-campaigns': 'analytics:view',
  'newsletter-settings': 'analytics:view',
  'marketing-campaigns': 'analytics:view',
  'marketing-sources': 'analytics:view',
  'marketing-conversion': 'analytics:view',
  'marketing-revenue': 'analytics:view',
  'marketing-journey': 'analytics:view',
  // Legacy group id (merged into marketing-group) — keep for deep links / old state.
  'google-ads-analytics-group': 'google_ads:view',
  'google-ads-dashboard': 'google_ads:view',
  'google-ads-campaigns': 'google_ads:view',
  // Alias of Marketing Dashboard (same page); kept for bookmarked /marketing-analytics/performance.
  'google-ads-performance': 'google_ads:view',
  'google-ads-keywords': 'google_ads:view',
  'google-ads-landing-pages': 'google_ads:view',
  // Alias of marketing-leads (same /marketing/leads route); kept for bookmarked menu ids.
  'google-ads-leads': 'analytics:view',
  'google-ads-attribution': 'google_ads:view',
  'google-ads-conversion-tracking': 'google_ads:view',
  'google-ads-spend-import': 'google_ads:manage',
  'google-ads-reports': 'google_ads:export',
  'google-ads-integrations': 'google_ads:view',
  'google-ads-settings-audit': 'google_ads:view',
  'ai-visibility-group': 'ai_visibility:view',
  'ai-visibility-dashboard': 'ai_visibility:view',
  'ai-visibility-urls': 'ai_visibility:view',
  'ai-visibility-crawlers': 'ai_visibility:view',
  'ai-visibility-keywords': 'ai_visibility:view',
  'ai-visibility-opportunities': 'ai_visibility:view',
  'ai-visibility-structured-data': 'ai_visibility:view',
  'ai-visibility-tests': 'ai_visibility:view',
  'ai-visibility-referrals': 'ai_visibility:view',
  'ai-visibility-reports': 'ai_visibility:export',
  'ai-visibility-seo-audit': 'ai_visibility:view',
  'ai-visibility-settings': 'ai_visibility:view',
  'utm-tracking-dashboard': 'utm_tracking:view',
  'utm-tracking-urls': 'utm_tracking:view',
  'utm-tracking-url-detail': 'utm_tracking:view',
  'brand-ads-group': 'ads:view',
  'brand-ads-dashboard': 'ads:view',
  'brand-ads-campaigns': 'ads:view',
  'brand-ads-advertisers': 'ads:view',
  'brand-ads-placements': 'ads:view',
  'brand-ads-landing': 'ads:view',
  'brand-ads-reports': 'ads:view',
  'brand-ads-settings': 'ads:manage',
  logs: 'logs:view',
  'qa-test-results': 'settings:view',
  'code-flow': 'dashboard:view',
  'dev-doc': 'dashboard:view',
  'db-backup': 'database:view',
  'cache-management': 'settings:view',
  settings: 'settings:view',
  'loyalty-settings': 'settings:view',
  'chatbot-settings': 'settings:view',
  'cancellation-settings': 'settings:view',
  'maintenance-settings': 'settings:view',
  'admin-ip-allowlist': 'admin:ip-allowlist:manage',
  'database-settings': 'database:view',
  'mobile-app-settings': 'settings:view',
  'website-design-settings': 'settings:view',
  'website-schema-settings': 'settings:view',
  'driver-app-settings': 'settings:view',
  'status-management': 'settings:view',
  'profile-settings': 'settings:view',
  'change-password': 'settings:view',
  acl: 'acl:view',
  'acl-all-users': 'acl:view',
  'acl-locked-users': 'acl:view',
  'acl-user-roles': 'acl:view',
  'acl-admin-access-log': 'acl:view',
};

function slugStaffRole(input) {
  return String(input || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '');
}

/** Normalize DB/UI role strings to ACL keys (matches BFF staff filter). */
export function canonicalAclRole(rawRole) {
  const r = slugStaffRole(rawRole);
  if (!r) return 'super_admin';
  if (r === 'admin') return 'super_admin';
  return r;
}

export function normalizeAdminUser(inputUser) {
  if (!inputUser || typeof inputUser !== 'object') return DEFAULT_ADMIN_USER;
  const role = canonicalAclRole(inputUser.role);
  const { password: _pw, passwordConfirm: _pc, ...rest } = inputUser;
  return {
    ...DEFAULT_ADMIN_USER,
    ...rest,
    role,
    permissions: resolveUserPermissions({ ...inputUser, role }),
  };
}

export function resolveUserPermissions(user) {
  const role = canonicalAclRole(user?.role);
  const rolePerms = ROLE_PERMISSIONS[role] || [];
  const directPerms = Array.isArray(user?.permissions) ? user.permissions : [];
  return Array.from(new Set([...rolePerms, ...directPerms]));
}

/** Pick default session user from GET /admin/staff-users rows. */
export function pickDefaultStaffRow(rows) {
  if (!Array.isArray(rows) || !rows.length) return null;
  const superFirst = rows.find((r) => {
    const n = canonicalAclRole(r.role);
    return n === 'super_admin' || n === 'admin';
  });
  return superFirst || rows[0];
}

/** Map a public.users row to admin SPA session shape. */
export function sessionUserFromStaffRow(row) {
  if (!row || typeof row !== 'object') return normalizeAdminUser(null);
  return normalizeAdminUser({
    id: row.id,
    name: row.name,
    email: row.email,
    role: row.role,
    status: row.status,
  });
}

export function hasPermission(user, permission) {
  const permissions = resolveUserPermissions(user);
  return permissions.includes('*') || permissions.includes(permission);
}

/** Super admin and admin only — security-critical settings. */
export function canManageSecuritySettings(user) {
  const role = slugStaffRole(user?.role);
  return role === 'super_admin' || role === 'admin';
}

/** @deprecated use canManageSecuritySettings */
export function canManageAdminIpAllowlist(user) {
  return canManageSecuritySettings(user);
}

export function canViewWatchtower(user) {
  return hasPermission(user, PERMISSIONS.WATCHTOWER_VIEW);
}

export function canAccessMenu(user, menuId) {
  const key = String(menuId || '').trim();
  if (!key) return false;
  if (key === 'admin-ip-allowlist' || key === 'attack-protection-settings' || key === 'active-sessions') {
    return canManageSecuritySettings(user);
  }
  const permission = MENU_PERMISSION[key];
  if (!permission) return true;
  return hasPermission(user, permission);
}

export function getFirstAllowedMenu(user, menuOrder = []) {
  const first = menuOrder.find((menuId) => canAccessMenu(user, menuId));
  return first || 'dashboard';
}

function canAccessMenuItem(user, item) {
  if (!item) return false;
  const permId = item.menuTargetId || item.id;
  return canAccessMenu(user, permId);
}

function filterMenuChildren(children, user) {
  return (Array.isArray(children) ? children : [])
    .map((child) => {
      if (child?.isGroup && Array.isArray(child.children)) {
        const nested = filterMenuChildren(child.children, user);
        if (!nested.length) return null;
        return { ...child, children: nested };
      }
      return canAccessMenuItem(user, child) ? child : null;
    })
    .filter(Boolean);
}

export function filterMenuItemsByAcl(items, user) {
  return (Array.isArray(items) ? items : [])
    .map((item) => {
      if (item?.isGroup && Array.isArray(item.children)) {
        const children = filterMenuChildren(item.children, user);
        if (!children.length) return null;
        return { ...item, children };
      }
      return canAccessMenuItem(user, item) ? item : null;
    })
    .filter(Boolean);
}

/** Filter sidebar sections; drop empty sections. */
export function filterSidebarSectionsByAcl(sections, user) {
  return (Array.isArray(sections) ? sections : [])
    .map((section) => {
      const items = filterMenuItemsByAcl(section.items, user);
      if (!items.length) return null;
      return { ...section, items };
    })
    .filter(Boolean);
}
